module.exports = __webpack_public_path__ + "files/08ae8b812a26abd85cca21adbf256f45.png";